export const Candle = ({ progress = 1, extinguished = false, size = 300, className = "" }) => {
  const p = Math.max(0, Math.min(1, progress));
  const liveOpacity = extinguished ? 0 : 0.6 + 0.4 * p;

  return (
    <div
      className={`candle-stage-wrap ${className}`}
      style={{ "--sz": typeof size === "number" ? `${size}px` : size }}
      data-testid="animated-candle"
    >
      <img src="/candle.png?v=2" alt="Bougie allumée en mémoire" className="candle-full" draggable="false" />
      <div className="candle-darkmask" />
      <div className="candle-live" style={{ opacity: liveOpacity }}>
        <svg className="candle-fx" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid meet" aria-hidden="true">
          <defs>
            <radialGradient id="fxGlow" cx="50%" cy="55%" r="50%">
              <stop offset="0%" stopColor="rgba(255,206,130,0.85)" />
              <stop offset="35%" stopColor="rgba(255,170,70,0.45)" />
              <stop offset="70%" stopColor="rgba(255,140,40,0.12)" />
              <stop offset="100%" stopColor="rgba(255,140,40,0)" />
            </radialGradient>
            <linearGradient id="fxFlame" x1="0" y1="1" x2="0" y2="0">
              <stop offset="0%" stopColor="#ff6a00" />
              <stop offset="35%" stopColor="#ff9a2e" />
              <stop offset="72%" stopColor="#ffce5c" />
              <stop offset="100%" stopColor="#fff0b0" />
            </linearGradient>
            <linearGradient id="fxInner" x1="0" y1="1" x2="0" y2="0">
              <stop offset="0%" stopColor="#ffd76a" />
              <stop offset="60%" stopColor="#fff4c8" />
              <stop offset="100%" stopColor="#ffffff" />
            </linearGradient>
            <radialGradient id="fxBlue" cx="50%" cy="50%" r="50%">
              <stop offset="0%" stopColor="rgba(120,170,255,0.9)" />
              <stop offset="100%" stopColor="rgba(120,170,255,0)" />
            </radialGradient>
            <linearGradient id="fxSmoke" x1="0" y1="1" x2="0" y2="0">
              <stop offset="0%" stopColor="rgba(190,190,195,0.55)" />
              <stop offset="45%" stopColor="rgba(180,180,188,0.32)" />
              <stop offset="100%" stopColor="rgba(180,180,188,0)" />
            </linearGradient>
            <filter id="fxSmokeF" x="-120%" y="-60%" width="340%" height="220%">
              <feTurbulence type="fractalNoise" baseFrequency="0.018 0.045" numOctaves="2" seed="4" result="t">
                <animate attributeName="baseFrequency" dur="14s" values="0.018 0.045;0.028 0.075;0.018 0.05;0.018 0.045" repeatCount="indefinite" />
                <animate attributeName="seed" dur="20s" values="1;8;1" repeatCount="indefinite" />
              </feTurbulence>
              <feDisplacementMap in="SourceGraphic" in2="t" scale="7" xChannelSelector="R" yChannelSelector="G" />
              <feGaussianBlur stdDeviation="0.55" />
            </filter>
            <filter id="fxFlameBlur" x="-60%" y="-60%" width="220%" height="220%">
              <feGaussianBlur stdDeviation="0.35" />
            </filter>
          </defs>

          {/* léger recentrage de la flamme vers la droite (alignement mèche) */}
          <g transform="translate(0.7 0)">
            {/* halo lumineux */}
            <ellipse className="fx-glow" cx="49.3" cy="34.5" rx="5.6" ry="7" fill="url(#fxGlow)" />

            {!extinguished && (
              <g className="fx-sway">
                {/* flamme : teardrop fine et élancée, vacille de gauche à droite */}
                <g className="fx-flicker">
                  <path className="fx-flame-outer" filter="url(#fxFlameBlur)"
                        d="M49.3 38.5 C 47.95 35.6 47.95 30 49.3 25.4 C 50.65 30 50.65 35.6 49.3 38.5 Z"
                        fill="url(#fxFlame)" />
                  <path className="fx-flame-inner"
                        d="M49.3 38.0 C 48.55 35.6 48.55 31.8 49.3 28.6 C 50.05 31.8 50.05 35.6 49.3 38.0 Z"
                        fill="url(#fxInner)" />
                  <ellipse cx="49.3" cy="35.7" rx="0.5" ry="1.9" fill="#ffffff" opacity="0.9" />
                  <ellipse className="fx-blue" cx="49.3" cy="37.8" rx="1.05" ry="1.7" fill="url(#fxBlue)" />
                </g>
              </g>
            )}
          </g>
        </svg>
      </div>
    </div>
  );
};
